import Cart from '@grafikr/shopify-typescript/type/Cart';

export const getCart = async (): Promise<Cart> => (
  await fetch(`${theme.routes.cart}.js`)
).json();

export default {
  getCart,
};
